import addDirectorySaga from './AddDirectory';

export const authznSagas = () => [
  addDirectorySaga()
];

export default authznSagas;
